<div class="points-shimmer-card">
    <div class="shimmer points-title"></div>

    <div class="shimmer points-value"></div>

    <div class="shimmer points-sub"></div>
</div>
